import { SET_CLIENT_HOME } from "../actions/action-types.js";

export default function clientHome(state = {}, {type, payload}) {
    switch (type) {
        case SET_CLIENT_HOME:
            return (state = payload)
        default:
            return state
    }
}